var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionFailure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.611328,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#FEF0C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1053_20241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.165 38.4999L85.98 79.7499C86.1994 80.1299 86.3149 80.561 86.3149 80.9999C86.3149 81.4387 86.1994 81.8698 85.98 82.2499C85.7606 82.6299 85.445 82.9455 85.065 83.1649C84.6849 83.3844 84.2538 83.4999 83.815 83.4999H36.185C35.7462 83.4999 35.3151 83.3844 34.935 83.1649C34.555 82.9455 34.2394 82.6299 34.02 82.2499C33.8006 81.8698 33.6851 81.4387 33.6851 80.9999C33.6851 80.561 33.8006 80.1299 34.02 79.7499L57.835 38.4999C58.0544 38.1199 58.37 37.8043 58.75 37.5849C59.1301 37.3655 59.5612 37.25 60 37.25C60.4388 37.25 60.8699 37.3655 61.2499 37.5849C61.63 37.8043 61.9456 38.1199 62.165 38.4999ZM40.515 78.4999H79.485L60 44.7499L40.515 78.4999ZM57.5 70.9999H62.5V75.9999H57.5V70.9999ZM57.5 53.4999H62.5V65.9999H57.5V53.4999Z",
    fill: "#F79009"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1053_20241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(30 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFailure);
export default __webpack_public_path__ + "static/media/transactionFailure.e66ef6b4d73065227f8fe921edf5a9dc.svg";
export { ForwardRef as ReactComponent };